import { useEffect, useState } from 'react';

//Components
import ApplyJob from '../../components/ApplyJob';
import CustomDataTable from '../../components/DataTable';
import JobDescription from '../../components/JobDescription';

//Constants
import { JOB_COLUMNS, JobModes } from '../../constants/general';

// Images
import applyJobIcon from '../../assets/images/apply-job-icon.svg';

//Utility Functions
import { getJobDetailsData } from '../../middleware/jobDetails';
import { dispatch } from '../../utils/store';

//Utility Packages
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Actions } from '../../redux/actions';

function Jobs() {
  // Store
  const { jobs, totalRecords, search, pageNumber, size, sortBy, orderBy } = useSelector(
    (state) => state.jobs
  );
  const toastRef = useSelector((state) => state.notifications.toastReff);

  // State
  const [jobDetails, setJobDetails] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [visibleApplyJob, setVisibleApplyJob] = useState(false);
  const [jobDescription, setJobDescription] = useState(null);
  const [visibleJobDescription, setVisibleJobDescription] = useState(false);

  useEffect(() => {
    getJobDetailsData(search, pageNumber, size, sortBy, orderBy, toastRef);
  }, [search, pageNumber, size, sortBy, orderBy, toastRef]);

  useEffect(() => {
    return () => {
      dispatch(Actions.Jobs.JobsReset);
    };
  }, []);

  useEffect(() => {
    if (jobs?.length) {
      const modifiedRecords = jobs.map((job) => ({
        ...job,
        Skills: job?.Skills?.length && (
          <div className="technology-chip-list flex flex-wrap gap-2">
            {job.Skills.map((skill) => (
              <Chip key={skill} label={skill} className="technology-chip" />
            ))}
          </div>
        ),
        Salary: `${job?.Salary ? job?.Salary + ' LPA' : '--'}`,
        Experience: `${job?.Experience} Y`,
        JobMode: `${JobModes.find((mode) => mode.value === job.JobMode)?.label || '--'}`,
        action: (
          <div className="table-actions-wrapper">
            <Button
              data-tooltip-id="job-description-button"
              data-tooltip-content="Job Description"
              icon="pi pi-info-circle"
              rounded
              text
              severity="secondary"
              aria-label="JobDescription"
              onClick={() => {
                setJobDescription(job.JobDescription);
                setVisibleJobDescription(true);
              }}
              className="grid-action-btn"
            />
            <Button
              data-tooltip-id="apply-job-button"
              data-tooltip-content="Apply Job"
              // icon="pi pi-file-check"
              rounded
              text
              severity="secondary"
              aria-label="ApplyJob"
              onClick={() => onApplyJobClick(job.ID)}
              className="grid-action-btn">
              <img src={applyJobIcon} alt="Apply Job" />
            </Button>
            <ReactTooltip id="job-description-button" place="top" />
            <ReactTooltip id="apply-job-button" place="top-end" />
          </div>
        )
      }));
      setJobDetails(modifiedRecords);
    } else {
      setJobDetails([]);
    }
  }, [jobs]);

  const onApplyJobClick = (ID) => {
    setSelectedJobId(ID);
    setVisibleApplyJob(true);
  };

  const onHideApplyJob = () => {
    setVisibleApplyJob(false);
    setSelectedJobId(null);
  };

  const handlePagination = (pageNumber, size) => {
    dispatch(Actions.Jobs.SetPageNumber, pageNumber);
    dispatch(Actions.Jobs.SetPageSize, size);
  };

  const handleSearch = (searchValue) => {
    dispatch(Actions.Jobs.SetSearch, searchValue);
  };

  const handleSort = (field) => {
    let sortOrder = 'ASC';
    if (sortBy === field) sortOrder = orderBy === 'ASC' ? 'DESC' : 'ASC';
    dispatch(Actions.Jobs.SetSortBy, field);
    dispatch(Actions.Jobs.SetOrderBy, sortOrder);
  };

  return (
    <div className="job-table-wrapper">
      <CustomDataTable
        data={jobDetails}
        onSearch={handleSearch}
        totalRecords={totalRecords}
        columns={JOB_COLUMNS}
        onPagination={handlePagination}
        onSort={handleSort}
      />
      <JobDescription
        visible={visibleJobDescription}
        description={jobDescription}
        onHide={() => setVisibleJobDescription(false)}
      />
      <ApplyJob selectedJobId={selectedJobId} visible={visibleApplyJob} onHide={onHideApplyJob} />
    </div>
  );
}

export default Jobs;
